define([
    'jquery',
    'js/widget-utils',
    './api'
], function ($, WidgetUtils, Google) {
    const namespace = 'aligent.googleMap';
    $.widget(namespace, {
        options: {
            readyClass: 'aligent-google-map--ready',
            movingClass: 'aligent-google-map--moving',
            center: null,
            zoom: 12,
            locations: [],
            gps: false,
            showDirections: false,
            googleMapsFullscreenPosition: 'TOP_RIGHT'
        },

        _create () {
            this.options = Object.assign({},
                                         this.options,
                                         WidgetUtils.optionsFromQueryString(namespace));
            Google.Ready().then((api) => {
                this.api = api;
                this.ready();
            });
        },

        ready () {
            this.element.addClass(this.options.readyClass);
            const mapOptions = $.extend({}, this.options.mapOptions, {
                fullscreenControlOptions: {
                    position: this.api.ControlPosition[this.options.googleMapsFullscreenPosition]
                }
            });
            this.mapControl = new this.api.Map(this.element.get(0), mapOptions);
            this.render();
        },

        renderMarker (options) {
            const marker = new this.api.Marker(Object.assign({
                clickable: false
            }, options));

            return marker;
        },

        setLocations(locations) {
            this.options.locations = locations;
            this.render();
        },

        render () {
            this.mapControl.setCenter(this.options.center);
            this.mapControl.setZoom(this.options.zoom);

            this.markers &&
                this.markers.length > 0 &&
                this.markers.forEach((marker) => marker.setMap(null));

            const bounds = [];
            this.markers = this.options.locations
                .map(location => {
                    const { lat, lng } = location.position;
                    const marker = this.renderMarker(location);
                    marker.setMap(this.mapControl);

                    const boundary = new this.api.LatLng(lat, lng);
                    bounds.push(boundary);

                    return marker;
                });

            if (bounds.length > 0) {
                const latLngBounds = new this.api.LatLngBounds();
                bounds.forEach((boundary) => {
                    latLngBounds.extend(boundary);
                });
                this.mapControl.fitBounds(latLngBounds);
            }
        }
    });

    return $.aligent.googleMap;

});
